package pl.michal_cyran.brand_hub.subpages.main.services

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaAndroid
import com.varabyte.kobweb.silk.components.icons.fa.FaBook
import com.varabyte.kobweb.silk.components.icons.fa.FaCode
import com.varabyte.kobweb.silk.components.icons.fa.FaSchool
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseIn
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.ServicesGridStyle
import pl.michal_cyran.brand_hub.ServicesSubtitleStyle
import pl.michal_cyran.brand_hub.ServicesTitleStyle
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun MainServicesSection() {
    val services = listOf(
        ServiceItem(
            id = "korepetycje",
            title = "Korepetycje z Matematyki",
            description = "Indywidualne zajęcia online. Przygotowanie do matury podstawowej i rozszerzonej, pomoc w bieżących lekcjach, egzamin ósmoklasisty.",
            features = listOf("Lekcje 1-na-1", "Elastyczne godziny", "Indywidualne podejście", "Przypomnienia o lekcjach"),
            icon = { FaSchool() },
            link = "/tutoring"
        ),
        ServiceItem(
            id = "aplikacja",
            title = "DayMath - Aplikacja Mobilna",
            description = "Ucz się matematyki w dowolnym miejscu i czasie. Interaktywne zadania, teoria i rozwiązania krok po kroku.",
            features = listOf("Android", "Tryb offline", "Postępy nauki", "Darmowa aplikacja"),
            icon = { FaAndroid() },
            link = "/day-math"
        ),
        ServiceItem(
            id = "matura",
            title = "Zadania Maturalne",
            description = "Pełna baza zadań maturalnych z rozwiązaniami. Filtruj po tematach, poziomach i latach.",
            features = listOf("2000+ zadań", "Rozwiązania wideo", "Częstość zadań", "Arkusze próbne"),
            icon = { FaBook() },
            link = "https://egzaminy.michal-cyran.pl/"
        ),
        ServiceItem(
            id = "freelancing",
            title = "Freelancing IT",
            description = "Tworzenie aplikacji mobilnych, desktopowych i/lub webowych. Nowoczesne technologie i profesjonalne podejście.",
            features = listOf("Android", "Desktop", "Konsultacje", "Utrzymanie"),
            icon = { FaCode() },
            link = "/freelancing"
        )
    )

    val c = ColorMode.current.toSitePalette() // however you currently resolve CyanColorsLight/Dark

    Box(
        Modifier
            .fillMaxWidth()
            .padding(topBottom = 96.px)
    ) {
        Column(Modifier.fillMaxWidth()) {
            VisibilityAware(
                modifier = Modifier.fillMaxWidth()
            ) { isVisible ->
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Box(
                        Modifier
                            .padding(topBottom = 6.px, leftRight = 14.px)
                            .borderRadius(999.px)
                            .backgroundColor(c.badgeBg)
                            .border(1.px, LineStyle.Solid, c.badgeBorder)
                            .color(c.badgeText)
                            .fontSize(13.px)
                            .fontWeight(FontWeight.Medium)
                            .opacity(if (isVisible) 1 else 0)
                            .transform { scale(if (isVisible) 1.0 else 0.6) }
                            .transition(
                                Transition.of("opacity", 0.4.s, EaseOut, 0.ms),
                                Transition.of("transform", 0.4.s, EaseIn, 0.ms)
                            )
                    ) { Text("Oferta") }

                    H2(
                        Modifier
                            .margin(top = 16.px)
                            .color(c.textHeading)
                            .opacity(if (isVisible) 1 else 0)
                            .transform { translateY(if (isVisible) 0.px else 12.px) }
                            .transition(
                                Transition.of("opacity", 0.4.s, EaseOut, 150.ms),
                                Transition.of("transform", 0.4.s, EaseOut, 150.ms)
                            )
                            .toAttrs()
                    ) {
                        Text("Co mogę dla Ciebie zrobić?")
                    }
                    P(
                        Modifier
                            .margin(top = 12.px, bottom = 56.px)
                            .color(c.textMuted)
                            .opacity(if (isVisible) 1 else 0)
                            .transform { translateY(if (isVisible) 0.px else 12.px) }
                            .transition(
                                Transition.of("opacity", 0.4.s, EaseOut, 250.ms),
                                Transition.of("transform", 0.4.s, EaseOut, 250.ms)
                            )
                            .toAttrs()
                    ) {
                        Text("Od korepetycji po tworzenie aplikacji — wybierz to, czego potrzebujesz")
                    }
                }
            }

            SimpleGrid(
                numColumns(base = 1, md = 2),
                Modifier.gap(28.px).fillMaxWidth()
            ) {
                services.forEachIndexed { index, service ->
                    ServiceCard(service, index + 1, c)
                }
            }
        }
    }
}
